import '@progress/kendo-theme-fluent/dist/all.scss'
import './App.scss';
import { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { RecoilRoot } from 'recoil';
import { ErrorPage, LoaderOverlay, Routing, Tooltip } from 'components';

function App() {
	return (
        <ErrorBoundary FallbackComponent={ErrorPage}>
            <RecoilRoot>
                <Suspense fallback={<LoaderOverlay isLoading type="infinite-spinner" />}>
                    <Tooltip>
                        <Routing />
                    </Tooltip>
                </Suspense>
            </RecoilRoot>
        </ErrorBoundary>
	);
}

export default App;